angular.module('autoremind.reports.communication')
    .directive('messagingDetailsReport', ['$rootScope', 'messagesService', '$interval', 'eventSharingService', '$location',
    function ($rootScope, messagesService, $interval, eventSharingService, $location) {
        return {
            // Added ng-include to be used by UpgradeComponent, otherwise throwing error 'loading directive templates asynchronously is not supported'
            template: `<ng-include src="'app/reports/communication/messages/messaging-details-report.html'"></ng-include>`,
            restrict: 'E',
            scope: {
                jobId: '='
            },
            link: function ($scope, elem, attr) {
                $scope.messagesService = messagesService;
                messagesService.clearModel();
                $scope.viewModel = {
                    loadingMessages: false
                };
                $scope.getMessages = function () {
                    messagesService.offset = messagesService.lastRegisteredId;
                    // debugger;
                    // TODO: Stop update if any - or at least make sure update is not possible
                    $scope.viewModel.loadingMessages = true;
                    messagesService.getMessages($scope.jobId, 'full', true)
                        .then(function () {
                        $scope.viewModel.loadingMessages = false;
                    }, function () {
                        $scope.viewModel.loadingMessages = false;
                    });
                };
                /**
                 * This is called by the in-view library when the element marking last line of messages is visible (in Messaging Report)
                 */
                $scope.getMoreMessagesOnScroll = function () {
                    if ($scope.jobId !== undefined) {
                        $scope.getMessages();
                    }
                    return false;
                };
                $scope.getMessages();
            }
        };
    }]);
//# sourceMappingURL=messaging-details-report.directive.js.map